import userRequired from 'hoc/userRequired';
import { StyleSheet, Text, View } from 'react-native';
import theme from 'theme';
import { calcSizeForDevice, calcSizeForTv } from 'utils/index';
import { Platform } from 'utils/platform';

import FocusView from 'components/FocusView';
import { SectionFavorite } from 'components/Section/SectionFavorite';

const FavoritesScreen: React.FC = () => {
  return (
    <FocusView trapFocusUp trapFocusRight style={{ flex: 1 }}>
      <View style={styles.container}>
        {Platform.isTV && <Text style={styles.titleText}>Minha Lista</Text>}
        <SectionFavorite {...(Platform.isTV && { topContainerHeight: calcSizeForTv(240) })} />
      </View>
    </FocusView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingBottom: calcSizeForDevice(32, 0),
    paddingHorizontal: calcSizeForDevice(32),
    marginTop: calcSizeForDevice(20, 120),
  },
  titleText: {
    color: 'white',
    fontSize: calcSizeForTv(48),
    lineHeight: calcSizeForTv(60),
    fontFamily: theme.fonts.inter.bold,
    marginBottom: calcSizeForTv(60),
  },
});

export default userRequired(FavoritesScreen);
